import Vue from 'vue';
import { getInstance } from '@/_kk_wallet_relock/plugins/vue';
import { Web3Provider } from '@ethersproject/providers';
import { Contract } from '@ethersproject/contracts';
import { getAddress } from '@ethersproject/address';
//import { multicall } from '@bonustrack/snapshot.js/src/utils';
//import spaces from '@/spaces';
import store from '@/store';
import abi from '@/helpers/abi';
import config from '@/helpers/config';
import wsProvider from '@/helpers/ws';
import rpcProvider from '@/helpers/rpc';
import '@ethersproject/units';
import { parseEther,formatEther } from '@ethersproject/units';
import {parseUnits,formatUnits} from "@ethersproject/units";
//import {rp} from "request-promise";

//const rp = import('request-promise');

import bus from '@/bus.js'
import Connector from '@/_kk_wallet_relock/src/connector';
let popPoast = function(obj_lang){
  if(window.location.href.indexOf('stake') == -1){
    return
  }

  let str = obj_lang['en']
  if(window.localStorage.lang === 'zh' &&　obj_lang['zh']){
    str = obj_lang['zh']
  }
  bus.appvue.$toasted.show(str)
  setTimeout(() => {
    bus.appvue.app_key += 1
  }, 2000);
}

let auth;
let web3;
if(window.ethereum){
  web3 = new Web3Provider(window.ethereum);
}

//kovan
// const TOKEN_ADDRESS = '0x0dBBe4Ab8BB3a0388C3088AfB028aE6871327b89'
//bsc
const TOKEN_ADDRESS = '0xc13b7a43223bb9bf4b69bd68ab20ca1b79d81c75'

const ERC20_ABI = '[{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"owner","type":"address"},{"indexed":true,"internalType":"address","name":"spender","type":"address"},{"indexed":false,"internalType":"uint256","name":"value","type":"uint256"}],"name":"Approval","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"from","type":"address"},{"indexed":true,"internalType":"address","name":"to","type":"address"},{"indexed":false,"internalType":"uint256","name":"value","type":"uint256"}],"name":"Transfer","type":"event"},{"inputs":[{"internalType":"address","name":"owner","type":"address"},{"internalType":"address","name":"spender","type":"address"}],"name":"allowance","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"spender","type":"address"},{"internalType":"uint256","name":"amount","type":"uint256"}],"name":"approve","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"account","type":"address"}],"name":"balanceOf","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"decimals","outputs":[{"internalType":"uint8","name":"","type":"uint8"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"spender","type":"address"},{"internalType":"uint256","name":"subtractedValue","type":"uint256"}],"name":"decreaseAllowance","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"spender","type":"address"},{"internalType":"uint256","name":"addedValue","type":"uint256"}],"name":"increaseAllowance","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"nonpayable","type":"function"},{"inputs":[],"name":"initialize","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"to","type":"address"},{"internalType":"uint256","name":"amount","type":"uint256"}],"name":"mint","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[],"name":"name","outputs":[{"internalType":"string","name":"","type":"string"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"symbol","outputs":[{"internalType":"string","name":"","type":"string"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"totalSupply","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"recipient","type":"address"},{"internalType":"uint256","name":"amount","type":"uint256"}],"name":"transfer","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"sender","type":"address"},{"internalType":"address","name":"recipient","type":"address"},{"internalType":"uint256","name":"amount","type":"uint256"}],"name":"transferFrom","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"nonpayable","type":"function"}]'


//kovan
// const HORSE_ADDRESS = '0x5002EdEEc32820Dd898a64f742984E340B1A734F'
//bsc
const HORSE_ADDRESS = '0x81dAbf61F918AffEeEff82c25879d898b32226CA'

const HORSE_ABI = '[{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"owner","type":"address"},{"indexed":true,"internalType":"address","name":"approved","type":"address"},{"indexed":true,"internalType":"uint256","name":"tokenId","type":"uint256"}],"name":"Approval","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"owner","type":"address"},{"indexed":true,"internalType":"address","name":"operator","type":"address"},{"indexed":false,"internalType":"bool","name":"approved","type":"bool"}],"name":"ApprovalForAll","type":"event"},{"anonymous":false,"inputs":[{"indexed":false,"internalType":"uint256","name":"tokenId","type":"uint256"},{"indexed":false,"internalType":"uint256","name":"price","type":"uint256"},{"indexed":false,"internalType":"uint256","name":"duration","type":"uint256"}],"name":"AuctionCreated","type":"event"},{"anonymous":false,"inputs":[{"indexed":false,"internalType":"uint256","name":"sireId","type":"uint256"},{"indexed":false,"internalType":"uint256","name":"matronId","type":"uint256"}],"name":"Bid","type":"event"},{"anonymous":false,"inputs":[{"indexed":false,"internalType":"uint256","name":"tokenId","type":"uint256"},{"indexed":false,"internalType":"uint256","name":"matronId","type":"uint256"},{"indexed":false,"internalType":"uint256","name":"sireId","type":"uint256"},{"indexed":false,"internalType":"enum ILion.Gender","name":"gender","type":"uint8"},{"indexed":false,"internalType":"uint256","name":"hair","type":"uint256"},{"indexed":false,"internalType":"uint256","name":"eye","type":"uint256"},{"indexed":false,"internalType":"uint256","name":"mouth","type":"uint256"},{"indexed":false,"internalType":"uint256","name":"background","type":"uint256"},{"indexed":false,"internalType":"uint256","name":"generation","type":"uint256"},{"indexed":false,"internalType":"address","name":"owner","type":"address"}],"name":"Birth","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"previousOwner","type":"address"},{"indexed":true,"internalType":"address","name":"newOwner","type":"address"}],"name":"OwnershipTransferred","type":"event"},{"anonymous":false,"inputs":[{"indexed":false,"internalType":"address","name":"account","type":"address"}],"name":"Paused","type":"event"},{"anonymous":false,"inputs":[{"indexed":false,"internalType":"uint256","name":"tokenId","type":"uint256"},{"indexed":false,"internalType":"string","name":"name","type":"string"}],"name":"SetName","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"from","type":"address"},{"indexed":true,"internalType":"address","name":"to","type":"address"},{"indexed":true,"internalType":"uint256","name":"tokenId","type":"uint256"}],"name":"Transfer","type":"event"},{"anonymous":false,"inputs":[{"indexed":false,"internalType":"address","name":"account","type":"address"}],"name":"Unpaused","type":"event"},{"inputs":[],"name":"BreedLimit","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"CoolDownTime","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"uint256","name":"","type":"uint256"}],"name":"Lions","outputs":[{"internalType":"string","name":"name","type":"string"},{"internalType":"enum ILion.Gender","name":"gender","type":"uint8"},{"internalType":"uint256","name":"hair","type":"uint256"},{"internalType":"uint256","name":"eye","type":"uint256"},{"internalType":"uint256","name":"mouth","type":"uint256"},{"internalType":"uint256","name":"background","type":"uint256"},{"internalType":"uint256","name":"generation","type":"uint256"},{"internalType":"uint256","name":"birthTime","type":"uint256"},{"internalType":"uint256","name":"matronId","type":"uint256"},{"internalType":"uint256","name":"sireId","type":"uint256"},{"internalType":"uint256","name":"breedCount","type":"uint256"},{"internalType":"uint256","name":"lastBreedTime","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"TimeForBreedAfterBorn","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"to","type":"address"},{"internalType":"uint256","name":"tokenId","type":"uint256"}],"name":"approve","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[],"name":"auctionDuration1","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"auctionDuration2","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"auctionDuration3","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"owner","type":"address"}],"name":"balanceOf","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"baseTokenURI","outputs":[{"internalType":"string","name":"","type":"string"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"uint256","name":"_sireId","type":"uint256"},{"internalType":"uint256","name":"_matronId","type":"uint256"}],"name":"bidOnSiringAuction","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[],"name":"breedPaused","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"_owner","type":"address"}],"name":"createFeMaleLion","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"_owner","type":"address"}],"name":"createMaleLion","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"uint256","name":"_LionId","type":"uint256"},{"internalType":"uint256","name":"_price","type":"uint256"},{"internalType":"uint256","name":"_duration","type":"uint256"}],"name":"createSiringAuction","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[],"name":"dev","outputs":[{"internalType":"address","name":"","type":"address"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"uint256","name":"tokenId","type":"uint256"}],"name":"getApproved","outputs":[{"internalType":"address","name":"","type":"address"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"_owner","type":"address"}],"name":"getLastBirth","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"_owner","type":"address"}],"name":"getLastMint","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"uint256","name":"_tokenId","type":"uint256"}],"name":"getLion","outputs":[{"components":[{"internalType":"string","name":"name","type":"string"},{"internalType":"enum ILion.Gender","name":"gender","type":"uint8"},{"internalType":"uint256","name":"hair","type":"uint256"},{"internalType":"uint256","name":"eye","type":"uint256"},{"internalType":"uint256","name":"mouth","type":"uint256"},{"internalType":"uint256","name":"background","type":"uint256"},{"internalType":"uint256","name":"generation","type":"uint256"},{"internalType":"uint256","name":"birthTime","type":"uint256"},{"internalType":"uint256","name":"matronId","type":"uint256"},{"internalType":"uint256","name":"sireId","type":"uint256"},{"internalType":"uint256[]","name":"offsprings","type":"uint256[]"},{"internalType":"uint256","name":"breedCount","type":"uint256"},{"internalType":"uint256","name":"lastBreedTime","type":"uint256"}],"internalType":"struct ILion.Lion","name":"","type":"tuple"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"getMintCounter","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"_dev","type":"address"},{"internalType":"address","name":"_mintToken","type":"address"},{"internalType":"uint256","name":"_mintPrice","type":"uint256"}],"name":"initialize","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"owner","type":"address"},{"internalType":"address","name":"operator","type":"address"}],"name":"isApprovedForAll","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"uint256","name":"_tokenId","type":"uint256"}],"name":"isOnAuction","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"","type":"address"}],"name":"lastBirth","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"","type":"address"}],"name":"lastMint","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"mintCounter","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"_owner","type":"address"}],"name":"mintLion","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"nonpayable","type":"function"},{"inputs":[],"name":"mintPrice","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"mintToken","outputs":[{"internalType":"contract IERC20Upgradeable","name":"","type":"address"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"name","outputs":[{"internalType":"string","name":"","type":"string"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"string","name":"","type":"string"}],"name":"nameToTokenId","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"owner","outputs":[{"internalType":"address","name":"","type":"address"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"uint256","name":"tokenId","type":"uint256"}],"name":"ownerOf","outputs":[{"internalType":"address","name":"","type":"address"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"paused","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"renounceOwnership","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"from","type":"address"},{"internalType":"address","name":"to","type":"address"},{"internalType":"uint256","name":"tokenId","type":"uint256"}],"name":"safeTransferFrom","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"from","type":"address"},{"internalType":"address","name":"to","type":"address"},{"internalType":"uint256","name":"tokenId","type":"uint256"},{"internalType":"bytes","name":"_data","type":"bytes"}],"name":"safeTransferFrom","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"operator","type":"address"},{"internalType":"bool","name":"approved","type":"bool"}],"name":"setApprovalForAll","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"string","name":"baseURI","type":"string"}],"name":"setBaseURI","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"bool","name":"_breedPaused","type":"bool"}],"name":"setBreedPaused","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"uint256","name":"_LionId","type":"uint256"},{"internalType":"string","name":"_name","type":"string"}],"name":"setLionName","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"_address","type":"address"}],"name":"setMintDevAddress","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"uint256","name":"_price","type":"uint256"}],"name":"setMintPrice","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"_address","type":"address"}],"name":"setMintToken","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"_address","type":"address"}],"name":"setSiringAuctionAddress","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[],"name":"siringAuction","outputs":[{"internalType":"contract IAuction","name":"","type":"address"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"bytes4","name":"interfaceId","type":"bytes4"}],"name":"supportsInterface","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"symbol","outputs":[{"internalType":"string","name":"","type":"string"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"testMintLion","outputs":[],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"uint256","name":"index","type":"uint256"}],"name":"tokenByIndex","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"owner","type":"address"},{"internalType":"uint256","name":"index","type":"uint256"}],"name":"tokenOfOwnerByIndex","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"uint256","name":"tokenId","type":"uint256"}],"name":"tokenURI","outputs":[{"internalType":"string","name":"","type":"string"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"totalSupply","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"from","type":"address"},{"internalType":"address","name":"to","type":"address"},{"internalType":"uint256","name":"tokenId","type":"uint256"}],"name":"transferFrom","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"newOwner","type":"address"}],"name":"transferOwnership","outputs":[],"stateMutability":"nonpayable","type":"function"}]'

//kovan
// const AUCTION_ADDRESS = '0xF70efb635A697d42Ac5167E8c72eCc9a6c0a2d32'
//bsc
const AUCTION_ADDRESS = '0x1A0ED9bB0FE950f74C713c6E0793Dff14561a550'


//kovan
// const HORSE_INTERFACE = '0xBDe8070D9f73830aD3da7BCbB9D65d1b06fF70dE'
// const HORSE_INTERFACE = '0xE5544E9E65F81f15720Dc8f9fCf961b5070E6442'
//bsc
const HORSE_INTERFACE = '0xbDEE64434186295cA5F0699d2E92c61710A5DDB4'
const HORSE_INTERFACE_ABI = '[{"inputs":[{"internalType":"address","name":"_nftAddress","type":"address"},{"internalType":"address","name":"_siringAuction","type":"address"},{"internalType":"address","name":"_nftMarket","type":"address"}],"stateMutability":"nonpayable","type":"constructor"},{"inputs":[{"internalType":"uint256","name":"_tokenId","type":"uint256"}],"name":"getLionDetail","outputs":[{"components":[{"components":[{"internalType":"uint256","name":"LionId","type":"uint256"},{"components":[{"internalType":"string","name":"name","type":"string"},{"internalType":"enum ILion.Gender","name":"gender","type":"uint8"},{"internalType":"uint256","name":"hair","type":"uint256"},{"internalType":"uint256","name":"eye","type":"uint256"},{"internalType":"uint256","name":"mouth","type":"uint256"},{"internalType":"uint256","name":"background","type":"uint256"},{"internalType":"uint256","name":"generation","type":"uint256"},{"internalType":"uint256","name":"birthTime","type":"uint256"},{"internalType":"uint256","name":"matronId","type":"uint256"},{"internalType":"uint256","name":"sireId","type":"uint256"},{"internalType":"uint256[]","name":"offsprings","type":"uint256[]"},{"internalType":"uint256","name":"breedCount","type":"uint256"},{"internalType":"uint256","name":"lastBreedTime","type":"uint256"}],"internalType":"struct ILion.Lion","name":"Lion","type":"tuple"},{"components":[{"internalType":"uint256","name":"price","type":"uint256"},{"internalType":"uint256","name":"duration","type":"uint256"},{"internalType":"uint256","name":"startedAt","type":"uint256"}],"internalType":"struct IAuction.Auction","name":"auctionInfo","type":"tuple"},{"internalType":"bool","name":"isOnAuction","type":"bool"}],"internalType":"struct LionInterface.LionSimple","name":"Lion","type":"tuple"},{"components":[{"internalType":"uint256","name":"LionId","type":"uint256"},{"components":[{"internalType":"string","name":"name","type":"string"},{"internalType":"enum ILion.Gender","name":"gender","type":"uint8"},{"internalType":"uint256","name":"hair","type":"uint256"},{"internalType":"uint256","name":"eye","type":"uint256"},{"internalType":"uint256","name":"mouth","type":"uint256"},{"internalType":"uint256","name":"background","type":"uint256"},{"internalType":"uint256","name":"generation","type":"uint256"},{"internalType":"uint256","name":"birthTime","type":"uint256"},{"internalType":"uint256","name":"matronId","type":"uint256"},{"internalType":"uint256","name":"sireId","type":"uint256"},{"internalType":"uint256[]","name":"offsprings","type":"uint256[]"},{"internalType":"uint256","name":"breedCount","type":"uint256"},{"internalType":"uint256","name":"lastBreedTime","type":"uint256"}],"internalType":"struct ILion.Lion","name":"Lion","type":"tuple"},{"components":[{"internalType":"uint256","name":"price","type":"uint256"},{"internalType":"uint256","name":"duration","type":"uint256"},{"internalType":"uint256","name":"startedAt","type":"uint256"}],"internalType":"struct IAuction.Auction","name":"auctionInfo","type":"tuple"},{"internalType":"bool","name":"isOnAuction","type":"bool"}],"internalType":"struct LionInterface.LionSimple","name":"matron","type":"tuple"},{"components":[{"internalType":"uint256","name":"LionId","type":"uint256"},{"components":[{"internalType":"string","name":"name","type":"string"},{"internalType":"enum ILion.Gender","name":"gender","type":"uint8"},{"internalType":"uint256","name":"hair","type":"uint256"},{"internalType":"uint256","name":"eye","type":"uint256"},{"internalType":"uint256","name":"mouth","type":"uint256"},{"internalType":"uint256","name":"background","type":"uint256"},{"internalType":"uint256","name":"generation","type":"uint256"},{"internalType":"uint256","name":"birthTime","type":"uint256"},{"internalType":"uint256","name":"matronId","type":"uint256"},{"internalType":"uint256","name":"sireId","type":"uint256"},{"internalType":"uint256[]","name":"offsprings","type":"uint256[]"},{"internalType":"uint256","name":"breedCount","type":"uint256"},{"internalType":"uint256","name":"lastBreedTime","type":"uint256"}],"internalType":"struct ILion.Lion","name":"Lion","type":"tuple"},{"components":[{"internalType":"uint256","name":"price","type":"uint256"},{"internalType":"uint256","name":"duration","type":"uint256"},{"internalType":"uint256","name":"startedAt","type":"uint256"}],"internalType":"struct IAuction.Auction","name":"auctionInfo","type":"tuple"},{"internalType":"bool","name":"isOnAuction","type":"bool"}],"internalType":"struct LionInterface.LionSimple","name":"sire","type":"tuple"},{"components":[{"internalType":"uint256","name":"LionId","type":"uint256"},{"components":[{"internalType":"string","name":"name","type":"string"},{"internalType":"enum ILion.Gender","name":"gender","type":"uint8"},{"internalType":"uint256","name":"hair","type":"uint256"},{"internalType":"uint256","name":"eye","type":"uint256"},{"internalType":"uint256","name":"mouth","type":"uint256"},{"internalType":"uint256","name":"background","type":"uint256"},{"internalType":"uint256","name":"generation","type":"uint256"},{"internalType":"uint256","name":"birthTime","type":"uint256"},{"internalType":"uint256","name":"matronId","type":"uint256"},{"internalType":"uint256","name":"sireId","type":"uint256"},{"internalType":"uint256[]","name":"offsprings","type":"uint256[]"},{"internalType":"uint256","name":"breedCount","type":"uint256"},{"internalType":"uint256","name":"lastBreedTime","type":"uint256"}],"internalType":"struct ILion.Lion","name":"Lion","type":"tuple"},{"components":[{"internalType":"uint256","name":"price","type":"uint256"},{"internalType":"uint256","name":"duration","type":"uint256"},{"internalType":"uint256","name":"startedAt","type":"uint256"}],"internalType":"struct IAuction.Auction","name":"auctionInfo","type":"tuple"},{"internalType":"bool","name":"isOnAuction","type":"bool"}],"internalType":"struct LionInterface.LionSimple[]","name":"offsprings","type":"tuple[]"},{"internalType":"uint256","name":"price","type":"uint256"}],"internalType":"struct LionInterface.LionDetail","name":"","type":"tuple"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"uint256","name":"_tokenId","type":"uint256"}],"name":"getLionSimple","outputs":[{"components":[{"internalType":"uint256","name":"LionId","type":"uint256"},{"components":[{"internalType":"string","name":"name","type":"string"},{"internalType":"enum ILion.Gender","name":"gender","type":"uint8"},{"internalType":"uint256","name":"hair","type":"uint256"},{"internalType":"uint256","name":"eye","type":"uint256"},{"internalType":"uint256","name":"mouth","type":"uint256"},{"internalType":"uint256","name":"background","type":"uint256"},{"internalType":"uint256","name":"generation","type":"uint256"},{"internalType":"uint256","name":"birthTime","type":"uint256"},{"internalType":"uint256","name":"matronId","type":"uint256"},{"internalType":"uint256","name":"sireId","type":"uint256"},{"internalType":"uint256[]","name":"offsprings","type":"uint256[]"},{"internalType":"uint256","name":"breedCount","type":"uint256"},{"internalType":"uint256","name":"lastBreedTime","type":"uint256"}],"internalType":"struct ILion.Lion","name":"Lion","type":"tuple"},{"components":[{"internalType":"uint256","name":"price","type":"uint256"},{"internalType":"uint256","name":"duration","type":"uint256"},{"internalType":"uint256","name":"startedAt","type":"uint256"}],"internalType":"struct IAuction.Auction","name":"auctionInfo","type":"tuple"},{"internalType":"bool","name":"isOnAuction","type":"bool"}],"internalType":"struct LionInterface.LionSimple","name":"","type":"tuple"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"uint256","name":"_tokenId","type":"uint256"},{"internalType":"uint256","name":"_price","type":"uint256"}],"name":"getLionSimpleWithPrice","outputs":[{"components":[{"internalType":"uint256","name":"LionId","type":"uint256"},{"components":[{"internalType":"string","name":"name","type":"string"},{"internalType":"enum ILion.Gender","name":"gender","type":"uint8"},{"internalType":"uint256","name":"hair","type":"uint256"},{"internalType":"uint256","name":"eye","type":"uint256"},{"internalType":"uint256","name":"mouth","type":"uint256"},{"internalType":"uint256","name":"background","type":"uint256"},{"internalType":"uint256","name":"generation","type":"uint256"},{"internalType":"uint256","name":"birthTime","type":"uint256"},{"internalType":"uint256","name":"matronId","type":"uint256"},{"internalType":"uint256","name":"sireId","type":"uint256"},{"internalType":"uint256[]","name":"offsprings","type":"uint256[]"},{"internalType":"uint256","name":"breedCount","type":"uint256"},{"internalType":"uint256","name":"lastBreedTime","type":"uint256"}],"internalType":"struct ILion.Lion","name":"Lion","type":"tuple"},{"components":[{"internalType":"uint256","name":"price","type":"uint256"},{"internalType":"uint256","name":"duration","type":"uint256"},{"internalType":"uint256","name":"startedAt","type":"uint256"}],"internalType":"struct IAuction.Auction","name":"auctionInfo","type":"tuple"},{"internalType":"bool","name":"isOnAuction","type":"bool"},{"internalType":"uint256","name":"price","type":"uint256"}],"internalType":"struct LionInterface.LionSimpleWithPrice","name":"","type":"tuple"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"nftMarket","outputs":[{"internalType":"contract INFTMarket","name":"","type":"address"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"nonFungibleContract","outputs":[{"internalType":"contract ILion","name":"","type":"address"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"siringAuction","outputs":[{"internalType":"contract IAuction","name":"","type":"address"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"_owner","type":"address"}],"name":"tokensOfOwner","outputs":[{"components":[{"internalType":"uint256","name":"LionId","type":"uint256"},{"components":[{"internalType":"string","name":"name","type":"string"},{"internalType":"enum ILion.Gender","name":"gender","type":"uint8"},{"internalType":"uint256","name":"hair","type":"uint256"},{"internalType":"uint256","name":"eye","type":"uint256"},{"internalType":"uint256","name":"mouth","type":"uint256"},{"internalType":"uint256","name":"background","type":"uint256"},{"internalType":"uint256","name":"generation","type":"uint256"},{"internalType":"uint256","name":"birthTime","type":"uint256"},{"internalType":"uint256","name":"matronId","type":"uint256"},{"internalType":"uint256","name":"sireId","type":"uint256"},{"internalType":"uint256[]","name":"offsprings","type":"uint256[]"},{"internalType":"uint256","name":"breedCount","type":"uint256"},{"internalType":"uint256","name":"lastBreedTime","type":"uint256"}],"internalType":"struct ILion.Lion","name":"Lion","type":"tuple"},{"components":[{"internalType":"uint256","name":"price","type":"uint256"},{"internalType":"uint256","name":"duration","type":"uint256"},{"internalType":"uint256","name":"startedAt","type":"uint256"}],"internalType":"struct IAuction.Auction","name":"auctionInfo","type":"tuple"},{"internalType":"bool","name":"isOnAuction","type":"bool"},{"internalType":"uint256","name":"price","type":"uint256"}],"internalType":"struct LionInterface.LionSimpleWithPrice[]","name":"","type":"tuple[]"}],"stateMutability":"view","type":"function"}]'


const GAS_Limit = 1200000

//kovan
// const nft_market_address = '0x76D954b6C467720EeC65784FB3d9F53c8445F435'
//bsc
const nft_market_address = '0xd6F8c8F6b0820137085DDE69a158C1c24d1A7745'
const nft_market_ABI = '[{"inputs":[{"internalType":"address","name":"_adminAddress","type":"address"},{"internalType":"address","name":"_treasuryAddress","type":"address"},{"internalType":"address","name":"_WBNBAddress","type":"address"},{"internalType":"uint256","name":"_minimumAskPrice","type":"uint256"},{"internalType":"uint256","name":"_maximumAskPrice","type":"uint256"}],"stateMutability":"nonpayable","type":"constructor"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"collection","type":"address"},{"indexed":true,"internalType":"address","name":"seller","type":"address"},{"indexed":true,"internalType":"uint256","name":"tokenId","type":"uint256"}],"name":"AskCancel","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"collection","type":"address"},{"indexed":true,"internalType":"address","name":"seller","type":"address"},{"indexed":true,"internalType":"uint256","name":"tokenId","type":"uint256"},{"indexed":false,"internalType":"uint256","name":"askPrice","type":"uint256"}],"name":"AskNew","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"collection","type":"address"},{"indexed":true,"internalType":"address","name":"seller","type":"address"},{"indexed":true,"internalType":"uint256","name":"tokenId","type":"uint256"},{"indexed":false,"internalType":"uint256","name":"askPrice","type":"uint256"}],"name":"AskUpdate","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"collection","type":"address"}],"name":"CollectionClose","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"collection","type":"address"},{"indexed":true,"internalType":"address","name":"creator","type":"address"},{"indexed":true,"internalType":"address","name":"whitelistChecker","type":"address"},{"indexed":false,"internalType":"uint256","name":"tradingFee","type":"uint256"},{"indexed":false,"internalType":"uint256","name":"creatorFee","type":"uint256"}],"name":"CollectionNew","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"collection","type":"address"},{"indexed":true,"internalType":"address","name":"creator","type":"address"},{"indexed":true,"internalType":"address","name":"whitelistChecker","type":"address"},{"indexed":false,"internalType":"uint256","name":"tradingFee","type":"uint256"},{"indexed":false,"internalType":"uint256","name":"creatorFee","type":"uint256"}],"name":"CollectionUpdate","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"admin","type":"address"},{"indexed":true,"internalType":"address","name":"treasury","type":"address"}],"name":"NewAdminAndTreasuryAddresses","type":"event"},{"anonymous":false,"inputs":[{"indexed":false,"internalType":"uint256","name":"minimumAskPrice","type":"uint256"},{"indexed":false,"internalType":"uint256","name":"maximumAskPrice","type":"uint256"}],"name":"NewMinimumAndMaximumAskPrices","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"token","type":"address"},{"indexed":true,"internalType":"uint256","name":"tokenId","type":"uint256"}],"name":"NonFungibleTokenRecovery","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"previousOwner","type":"address"},{"indexed":true,"internalType":"address","name":"newOwner","type":"address"}],"name":"OwnershipTransferred","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"claimer","type":"address"},{"indexed":false,"internalType":"uint256","name":"amount","type":"uint256"}],"name":"RevenueClaim","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"token","type":"address"},{"indexed":false,"internalType":"uint256","name":"amount","type":"uint256"}],"name":"TokenRecovery","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"collection","type":"address"},{"indexed":true,"internalType":"uint256","name":"tokenId","type":"uint256"},{"indexed":true,"internalType":"address","name":"seller","type":"address"},{"indexed":false,"internalType":"address","name":"buyer","type":"address"},{"indexed":false,"internalType":"uint256","name":"askPrice","type":"uint256"},{"indexed":false,"internalType":"uint256","name":"netPrice","type":"uint256"},{"indexed":false,"internalType":"bool","name":"withBNB","type":"bool"}],"name":"Trade","type":"event"},{"inputs":[],"name":"TOTAL_MAX_FEE","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"WBNB","outputs":[{"internalType":"address","name":"","type":"address"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"_collection","type":"address"},{"internalType":"address","name":"_creator","type":"address"},{"internalType":"address","name":"_whitelistChecker","type":"address"},{"internalType":"uint256","name":"_tradingFee","type":"uint256"},{"internalType":"uint256","name":"_creatorFee","type":"uint256"}],"name":"addCollection","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[],"name":"adminAddress","outputs":[{"internalType":"address","name":"","type":"address"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"_collection","type":"address"},{"internalType":"uint256","name":"_tokenId","type":"uint256"}],"name":"buyTokenUsingBNB","outputs":[],"stateMutability":"payable","type":"function"},{"inputs":[{"internalType":"address","name":"_collection","type":"address"},{"internalType":"uint256","name":"_tokenId","type":"uint256"},{"internalType":"uint256","name":"_price","type":"uint256"}],"name":"buyTokenUsingWBNB","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"collection","type":"address"},{"internalType":"uint256","name":"price","type":"uint256"}],"name":"calculatePriceAndFeesForCollection","outputs":[{"internalType":"uint256","name":"netPrice","type":"uint256"},{"internalType":"uint256","name":"tradingFee","type":"uint256"},{"internalType":"uint256","name":"creatorFee","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"_collection","type":"address"},{"internalType":"uint256[]","name":"_tokenIds","type":"uint256[]"}],"name":"canTokensBeListed","outputs":[{"internalType":"bool[]","name":"listingStatuses","type":"bool[]"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"_collection","type":"address"},{"internalType":"uint256","name":"_tokenId","type":"uint256"}],"name":"cancelAskOrder","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[],"name":"claimPendingRevenue","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"_collection","type":"address"}],"name":"closeCollectionForTradingAndListing","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"_collection","type":"address"},{"internalType":"uint256","name":"_tokenId","type":"uint256"},{"internalType":"uint256","name":"_askPrice","type":"uint256"}],"name":"createAskOrder","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[],"name":"maximumAskPrice","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"minimumAskPrice","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"_collection","type":"address"},{"internalType":"uint256","name":"_tokenId","type":"uint256"},{"internalType":"uint256","name":"_newPrice","type":"uint256"}],"name":"modifyAskOrder","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"_collection","type":"address"},{"internalType":"address","name":"_creator","type":"address"},{"internalType":"address","name":"_whitelistChecker","type":"address"},{"internalType":"uint256","name":"_tradingFee","type":"uint256"},{"internalType":"uint256","name":"_creatorFee","type":"uint256"}],"name":"modifyCollection","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"","type":"address"},{"internalType":"address","name":"","type":"address"},{"internalType":"uint256","name":"","type":"uint256"},{"internalType":"bytes","name":"","type":"bytes"}],"name":"onERC721Received","outputs":[{"internalType":"bytes4","name":"","type":"bytes4"}],"stateMutability":"nonpayable","type":"function"},{"inputs":[],"name":"owner","outputs":[{"internalType":"address","name":"","type":"address"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"","type":"address"}],"name":"pendingRevenue","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"_token","type":"address"}],"name":"recoverFungibleTokens","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"_token","type":"address"},{"internalType":"uint256","name":"_tokenId","type":"uint256"}],"name":"recoverNonFungibleToken","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[],"name":"renounceOwnership","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"_adminAddress","type":"address"},{"internalType":"address","name":"_treasuryAddress","type":"address"}],"name":"setAdminAndTreasuryAddresses","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"newOwner","type":"address"}],"name":"transferOwnership","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[],"name":"treasuryAddress","outputs":[{"internalType":"address","name":"","type":"address"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"uint256","name":"_minimumAskPrice","type":"uint256"},{"internalType":"uint256","name":"_maximumAskPrice","type":"uint256"}],"name":"updateMinimumAndMaximumPrices","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"collection","type":"address"},{"internalType":"uint256","name":"cursor","type":"uint256"},{"internalType":"uint256","name":"size","type":"uint256"}],"name":"viewAsksByCollection","outputs":[{"internalType":"uint256[]","name":"tokenIds","type":"uint256[]"},{"components":[{"internalType":"address","name":"seller","type":"address"},{"internalType":"uint256","name":"price","type":"uint256"}],"internalType":"struct ERC721NFTMarketV1.Ask[]","name":"askInfo","type":"tuple[]"},{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"collection","type":"address"},{"internalType":"address","name":"seller","type":"address"},{"internalType":"uint256","name":"cursor","type":"uint256"},{"internalType":"uint256","name":"size","type":"uint256"}],"name":"viewAsksByCollectionAndSeller","outputs":[{"internalType":"uint256[]","name":"tokenIds","type":"uint256[]"},{"components":[{"internalType":"address","name":"seller","type":"address"},{"internalType":"uint256","name":"price","type":"uint256"}],"internalType":"struct ERC721NFTMarketV1.Ask[]","name":"askInfo","type":"tuple[]"},{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"collection","type":"address"},{"internalType":"uint256[]","name":"tokenIds","type":"uint256[]"}],"name":"viewAsksByCollectionAndTokenIds","outputs":[{"internalType":"bool[]","name":"statuses","type":"bool[]"},{"components":[{"internalType":"address","name":"seller","type":"address"},{"internalType":"uint256","name":"price","type":"uint256"}],"internalType":"struct ERC721NFTMarketV1.Ask[]","name":"askInfo","type":"tuple[]"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"uint256","name":"cursor","type":"uint256"},{"internalType":"uint256","name":"size","type":"uint256"}],"name":"viewCollections","outputs":[{"internalType":"address[]","name":"collectionAddresses","type":"address[]"},{"components":[{"internalType":"enum ERC721NFTMarketV1.CollectionStatus","name":"status","type":"uint8"},{"internalType":"address","name":"creatorAddress","type":"address"},{"internalType":"address","name":"whitelistChecker","type":"address"},{"internalType":"uint256","name":"tradingFee","type":"uint256"},{"internalType":"uint256","name":"creatorFee","type":"uint256"}],"internalType":"struct ERC721NFTMarketV1.Collection[]","name":"collectionDetails","type":"tuple[]"},{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"}]'

// const a_INTERFACE = '0xa320aE264278476be187468Ff38E4f6B883b3B92'
// const a_ABI = '[{"inputs":[{"internalType":"address","name":"_authority","type":"address"},{"internalType":"address","name":"_airdropToken","type":"address"},{"internalType":"bytes32","name":"_merkleRoot","type":"bytes32"}],"stateMutability":"nonpayable","type":"constructor"},{"anonymous":false,"inputs":[{"indexed":false,"internalType":"uint256","name":"index","type":"uint256"},{"indexed":false,"internalType":"address","name":"account","type":"address"},{"indexed":false,"internalType":"uint256","name":"amount","type":"uint256"}],"name":"Claimed","type":"event"},{"inputs":[],"name":"airdropToken","outputs":[{"internalType":"address","name":"","type":"address"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"amountPerUser","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"authority","outputs":[{"internalType":"address","name":"","type":"address"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"uint256","name":"index","type":"uint256"},{"internalType":"bytes32[]","name":"merkleProof","type":"bytes32[]"}],"name":"claim","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[],"name":"emergencyWithdraw","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"uint256","name":"index","type":"uint256"}],"name":"isClaimed","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"merkleRoot","outputs":[{"internalType":"bytes32","name":"","type":"bytes32"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"uint256","name":"_amountPerUser","type":"uint256"}],"name":"setAmountPerUser","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"_authority","type":"address"}],"name":"setAuthority","outputs":[],"stateMutability":"nonpayable","type":"function"}]'

/*
wsProvider.on('block', blockNumber => {
  store.commit('GET_BLOCK_SUCCESS', blockNumber);
});
*/


const state = {
  injectedLoaded: false,
  injectedChainId: null,
  account: null,
  account_balance_eth: 0,
  account_balance_lp: 0,
  account_balance_sitetoken: '0',

  account_balance_isitetoken: '0',
  status_isitetoken_approved: undefined,
  status_hasApproveMint_lion: false,

  token_sitetoken_price: '-',
  token_ht_price: '-',
  
  name: null,
  active: false,
  balances: {},
  blockNumber: 0,
  status_account_approved: false, //是否参与farm stake
};


// utils
let cutNumber = function(number,float_length){
  let num = number + ''
  if (num.indexOf('.') > 0) {
    let arr = num.split('.')
    num = arr[0] + '.' + arr[1].substr(0, float_length)
  }
  return parseFloat(num)
}
let wait = function (ms) {
  return new Promise((resolve) => {
    setTimeout(() => {
      console.log("waiting " + ms);
      resolve(ms)
    }, ms)
  })
}
// utils end

// apollo
  import {
    ApolloClient,
    InMemoryCache,
    createHttpLink,
    ApolloProvider,
    useQuery,
    gql
  } from "@apollo/client";
import { stat } from 'fs';


  const httpLink = createHttpLink({
    //kovan
    // uri: 'https://api.thegraph.com/subgraphs/name/lavaswapdefi/lion',
    //bsc
    // uri: 'https://api.thegraph.com/subgraphs/name/juggerverse/metaverse',
    uri: 'https://api.thegraph.com/subgraphs/name/juggerverse/metaverse2',
  })

  // 缓存实现
  const cache = new InMemoryCache()
// apollo end

// 
const mutations = {
  setWeb3Data(state,obj){
    for(let key in obj){
      state[key] = obj[key]
    }
  },
  LOGOUT(_state) {
    Vue.set(_state, 'injectedLoaded', false);
    Vue.set(_state, 'injectedChainId', null);
    Vue.set(_state, 'account', null);
    Vue.set(_state, 'name', null);
    Vue.set(_state, 'active', false);
    Vue.set(_state, 'balances', {});
    console.debug('LOGOUT');
  },
  LOAD_WEB3_REQUEST() {
    console.debug('LOAD_WEB3_REQUEST');
  },
  LOAD_WEB3_SUCCESS() {
    console.debug('LOAD_WEB3_SUCCESS');
  },
  LOAD_WEB3_FAILURE(_state, payload) {
    console.debug('LOAD_WEB3_FAILURE', payload);
  },
  LOAD_PROVIDER_REQUEST() {
    console.debug('LOAD_PROVIDER_REQUEST');
  },
  LOAD_PROVIDER_SUCCESS(_state, payload) {
    Vue.set(_state, 'injectedLoaded', payload.injectedLoaded);
    Vue.set(_state, 'injectedChainId', payload.injectedChainId);
    Vue.set(_state, 'account', payload.account);
    Vue.set(_state, 'name', payload.name);
    console.debug('LOAD_PROVIDER_SUCCESS');
  },
  LOAD_PROVIDER_FAILURE(_state, payload) {
    Vue.set(_state, 'injectedLoaded', false);
    Vue.set(_state, 'injectedChainId', null);
    Vue.set(_state, 'account', null);
    Vue.set(_state, 'active', false);
    console.debug('LOAD_PROVIDER_FAILURE', payload);
  },
  LOAD_BACKUP_PROVIDER_REQUEST() {
    console.debug('LOAD_BACKUP_PROVIDER_REQUEST');
  },
  LOAD_BACKUP_PROVIDER_SUCCESS(_state, payload) {
    console.debug('LOAD_BACKUP_PROVIDER_SUCCESS', payload);
  },
  LOAD_BACKUP_PROVIDER_FAILURE(_state, payload) {
    Vue.set(_state, 'injectedLoaded', false);
    Vue.set(_state, 'backUpLoaded', false);
    Vue.set(_state, 'account', null);
    Vue.set(_state, 'activeChainId', null);
    Vue.set(_state, 'active', false);
    console.debug('LOAD_BACKUP_PROVIDER_FAILURE', payload);
  },
  HANDLE_CHAIN_CHANGED() {
    console.debug('HANDLE_CHAIN_CHANGED');
  },
  HANDLE_ACCOUNTS_CHANGED(_state, payload) {
    Vue.set(_state, 'account', payload);
    console.debug('HANDLE_ACCOUNTS_CHANGED', payload);
  },
  HANDLE_CLOSE_CHANGED() {
    console.debug('HANDLE_CLOSE_CHANGED');
  },
  HANDLE_NETWORK_CHANGED() {
    console.debug('HANDLE_NETWORK_CHANGED');
  },
  LOOKUP_ADDRESS_REQUEST() {
    console.debug('LOOKUP_ADDRESS_REQUEST');
  },
  LOOKUP_ADDRESS_SUCCESS(_state, payload) {
    Vue.set(_state, 'name', payload);
    console.debug('LOOKUP_ADDRESS_SUCCESS');
  },
  LOOKUP_ADDRESS_FAILURE(_state, payload) {
    console.debug('LOOKUP_ADDRESS_FAILURE', payload);
  },
  RESOLVE_NAME_REQUEST() {
    console.debug('RESOLVE_NAME_REQUEST');
  },
  RESOLVE_NAME_SUCCESS() {
    console.debug('RESOLVE_NAME_SUCCESS');
  },
  RESOLVE_NAME_FAILURE(_state, payload) {
    console.debug('RESOLVE_NAME_FAILURE', payload);
  },
  SEND_TRANSACTION_REQUEST() {
    console.debug('SEND_TRANSACTION_REQUEST');
  },
  SEND_TRANSACTION_SUCCESS() {
    console.debug('SEND_TRANSACTION_SUCCESS');
  },
  SEND_TRANSACTION_FAILURE(_state, payload) {
    console.debug('SEND_TRANSACTION_FAILURE', payload);
  },
  SIGN_MESSAGE_REQUEST() {
    console.debug('SIGN_MESSAGE_REQUEST');
  },
  SIGN_MESSAGE_SUCCESS() {
    console.debug('SIGN_MESSAGE_SUCCESS');
  },
  SIGN_MESSAGE_FAILURE(_state, payload) {
    console.debug('SIGN_MESSAGE_FAILURE', payload);
  },
  GET_BLOCK_REQUEST() {
    console.debug('GET_BLOCK_REQUEST');
  },
  GET_BLOCK_SUCCESS(_state, payload) {
    Vue.set(_state, 'blockNumber', payload);
    console.debug('GET_BLOCK_SUCCESS', payload);
  },
  GET_BLOCK_FAILURE(_state, payload) {
    console.debug('GET_BLOCK_FAILURE', payload);
  },
  METADATA_SUCCESS(_state, payload) {
    Vue.set(_state, 'spaces', payload);
    console.debug('METADATA_SUCCESS');
  }
};

// 

let fromResultToHorse =  function(result,tokenID){
  let di = {}
  di['tokenID'] = tokenID

  di['gender'] = parseInt(result['gender'])
  let gender_array = ['Male', 'Female']
  di['gender_str'] = gender_array[di['gender']]
  if(di['gender'] == 0){
    di['is_male'] = true
  }
  else{
    di['is_male'] = false;
  }

  di['hair'] = parseInt(result['hair'])
  // let hair_array = ['Black','Brown','Grey', 'Red', 'Yellow']
  let hair_array = ['Brown','Black','Blond','Gray','Green','Blue']
  di['hair_str'] = hair_array[di['hair']]

  di['eye'] = parseInt(result['eye'])
  // let eye_array = ['Type 1 Blue','Type 1 Brown','Type 1 Green','Type 2Blue','Type 2 Brown','Type 2 Green','Type 3 Blue','Type 3 Brown','Type 3 Green','Type 4 Cute','Type 5']
  // let eye_array = ['Zombie1','Zombie2','Tech1','Tech2','Magic1','Magic2']
  let eye_array = ['Magic1','Magic2','Tech1','Tech2','Zombie1','Zombie2']
  di['eye_str'] = eye_array[di['eye']]

  di['mouth'] = parseInt(result['mouth'])
  // let mouth_array = ['Smiley', 'Pup Mouth', 'Tongue Out', 'Roar Mouth', 'Scary Mouth']
  let mouth_array = ['Mouth1','Mouth2','Mouth3','Mouth4','Mouth5','Mouth6','Mouth7','Mouth8','Mouth9','Mouth10']
  di['mouth_str'] = mouth_array[di['mouth']]

  di['background'] = parseInt(result['background'])
  // let background_array = ['Builder','Park','Butterfly','Cool Light','Music','Rainbow','Red Lightening','Basketball','Pink','Cyan','Sky','Pink 2','Yellow Gradient','Purple Gradient','Night Light','Pink Gradient']
  let background_array = ['Blue','PINK', 'Blue Gradient','Forest','Day','Night','Rock','Chamber','Castle','Fountain']
  di['background_str'] = background_array[di['background']]



  let fileName = (di['background']+1).toString() + '0' +   ((1-di['gender'])*6 + di['hair']+1).toString() + '0' +  (di['eye']+1).toString() + '0' + (di['mouth']+1).toString()

  // di['image_url'] = 'https://lionnft.s3.ap-northeast-1.amazonaws.com/lions/' + fileName + '.jpg'
  // di['image_url'] = 'https://lionnft.s3.ap-northeast-1.amazonaws.com/lions2/1161.jpg'
  di['image_url'] = 'https://lionnft.s3.ap-northeast-1.amazonaws.com/lions8/' + fileName + '.jpg'
  
  di['generation'] = parseInt(result['generation'])


  di['name'] = result['name'];
  
  
  di['battle_level'] =   di['hair'] + 1
  di['battle_power'] = (di['mouth'] + 1) * 100
  di['battle_multiplier'] = 2 + di['background'] * 0.1
  
  di['bloodline'] = 0
  let bloodline_array = ['Nakamoto', 'Szabo', 'Finney', 'Buterin']
  di['bloodline_str'] = bloodline_array[di['bloodline']]
  di['genotype'] = 1
  di['breedtype'] = 0
  let breedType_array = ['Genesis', 'Legendary', 'Exclusive', 'Elite', 'Cross', 'Pacer']
  di['breedtype_str'] = breedType_array[di['breedtype']]
  di['coatcolourR'] =  0
  di['coatcolourG'] =  0
  di['coatcolourB'] =  0

  // console.log('------------------2')

  di['birthTime'] = parseInt(result['birthTime'])
  di['matronId'] = parseInt(result['matronId'])
  di['sireId'] = parseInt(result['sireId'])



  di['offsprings'] = []

  return di
}

let fromResultToAuction =  function(result){


  let di = {}

  di['duration'] = parseInt(result['duration'])
  di['price'] = formatEther(result['price'])
  di['startedAt'] =  parseInt(result['startedAt'])

  // console.log('------------------1111111')

  let now0 = Math.floor(Date.now() / 1000)
  di['timeLeft'] = 0
  if(di['startedAt'] + di['duration'] > now0){
    let a = di['startedAt'] + di['duration'] - now0
    let days = Math.floor(a / (24*3600))
    let hours = Math.floor((a - days*24*3600) / 3600)
    let minutes = Math.floor((a - days*24*3600 - hours*3600)/60)
    if(days == 0){
      if(hours == 0){
        di['timeLeft'] = minutes.toString() + 'm'
      }
      else{
        di['timeLeft'] = hours.toString() + 'h ' + minutes.toString() + 'm'
      }
    }
    else{
      di['timeLeft'] = days.toString() + 'd ' + hours.toString() + 'h ' + minutes.toString() + 'm'
    }
  }

  // console.log('------------------22222')

  return di;
}


// let fromResultToRace =  function(result,raceID){
//   let di = {}
//   di['raceID'] = raceID
//   di['horseNumber'] = parseInt(result['horseNumber'])
//   di['startedAt'] = parseInt(result['startedAt'])
//   if(di['startedAt'] > 0){
//     di['startedAt'] = di['startedAt'] + 2*60
//   }



//   di['createdAt'] = parseInt(result['createdAt'])

//   di['price'] = formatEther(result['price'])
//   di['status'] =  parseInt(result['status'])

//   di['raceLevel'] = parseInt(result['raceLevel'])
//   let raceLevel_array =  ['Griffin', 'Class5', 'Class4', 'Class3', 'Class2', 'Class1']
//   di['raceLevel_str'] = raceLevel_array[di['raceLevel']]

//   di['eventName'] = result['eventName']
//   di['location'] = result['location']
//   di['distance'] = parseInt(result['distance'])
//   let distance_array = ['1000m', '1200m', '1400m', '1600m', '1800m', '2000m', '2200m', '2400m']
//   di['distance_str'] = distance_array[di['distance']]

//   di['real_horses'] = result['horses']

//   let horses:any = []
//   for (let i = 0; i < result['horseIds'].length; i++) {
//     let tokenId = parseInt(result['horseIds'][i]);
//     if(tokenId > 0){
//         for (let j = 0; j < result['horses'].length; j++) {
//           const element = result['horses'][j];
//           if(tokenId == parseInt(element['id'])){
//             let h = fromResultToHorse(element,tokenId)
//             h['horseRaceInfo'] = fromResultToHorseRaceInfo(element)
//             horses[i] = h
//           }
//         }
//     }
//   }
//   if(horses.length == 0){
//     horses = [null,null,null,null,null]
//   }
//   di['horses'] = horses
//   di['getRaceHorseIds'] = horses


//   let result_horses:any = []
//   for (let i = 0; i < result['resultIds'].length; i++) {
//     let index = parseInt(result['resultIds'][i]);
//     let tokenId = parseInt(result['horseIds'][index]);
//     if(tokenId > 0){
//         for (let j = 0; j < result['horses'].length; j++) {
//           const element = result['horses'][j];
//           if(tokenId == parseInt(element['id'])){
//             let h = fromResultToHorse(element,tokenId)
//             h['horseRaceInfo'] = fromResultToHorseRaceInfo(element)
//             result_horses[i] = h
//           }
//         }
//     }
//   }
//   di['getRaceResult'] = result_horses

//   return di;
// }

let fromResultToBreedLimitInfo = function(result){
  
  // console.log('-------------ccc')
  // console.log(result)

  let di = {}
  di['breedCounter'] = result['breedCount']
  di['breedLimit'] = 7
  di['breedLeft'] = di['breedLimit'] - di['breedCounter']
  di['left'] = 0
  // di['left_str'] = '0'

  if(di['breedCounter'] == 0){
      // let a = parseInt(result['birthTime'])  + 2 * 24 * 3600;
      // let now = new Date().getTime()/1000;
      // if(a > now){
      //     di['left'] = a - now;
      // }
      let generation = parseInt(result['generation'])
      if(generation == 0){
        di['left'] = 0
      }
      else{
        let a = parseInt(result['birthTime'])  + 7 * 24 * 3600;
        let now = new Date().getTime()/1000;
        if(a > now){
            di['left'] = a - now;
        }
      }
  }
  else{
    let a = parseInt(result['lastBreedTime'])  + 7 * 24 * 3600;
    let now = new Date().getTime()/1000;
    // console.log('-------aa')
    // console.log(a)
    // console.log(now)
    if(a > now){
        di['left'] = a - now;
    }
  }

  // di['breedCounter'] = parseInt(result['breedCounter'])
  // di['breedLimit'] = parseInt(result['breedLimit'])
  // di['breedLeft'] = di['breedLimit'] - di['breedCounter']
  // di['left'] = parseInt(result['left']);


  // di['left_str'] = '0'
  
    let a = di['left']
    let days = Math.floor(a / (24*3600))
    let hours = Math.floor((a - days*24*3600) / 3600)
    let minutes = Math.floor((a - days*24*3600 - hours*3600)/60)
    if(days == 0){
      if(hours == 0){
        di['left_str'] = minutes.toString() + 'm'
      }
      else{
        di['left_str'] = hours.toString() + 'h ' + minutes.toString() + 'm'
      }
    }
    else{
      di['left_str'] = days.toString() + 'd ' + hours.toString() + 'h ' + minutes.toString() + 'm'
    }

  return di;
}


let fromResultToHorseRaceInfo =  function(result){
  console.log('fromResultToHorseRaceInfo')
  console.log(result)
  let di = {}
  di['raced'] = result['raced']
  di['racesNumber'] = parseInt(result['racesNumber'])
  di['points'] = parseInt(result['points'])
  di['firstNumber'] = parseInt(result['firstNumber'])
  di['secondNumber'] = parseInt(result['secondNumber'])
  di['thirdNumber'] = parseInt(result['thirdNumber'])
  console.log(di)
  return di;
}



const actions = {

  async getConnectedAccount(store){
    
    return store.state.account
  },

  login: async ({ dispatch }, connector = 'injected') => {
    console.log('into----web3.ts login()----')
    auth = getInstance();
    await auth.login(connector);
    if (auth.provider) {
      web3 = new Web3Provider(auth.provider);
      await dispatch('loadWeb3');
    }
  },
  logout: async ({ commit }) => {
    Vue.prototype.$auth.logout();
    commit('LOGOUT');
  },
  loadWeb3: async ({ commit, dispatch }) => {
    commit('LOAD_WEB3_REQUEST');
    try {
      await dispatch('loadProvider');
      await dispatch('lookupAddress');
      commit('LOAD_WEB3_SUCCESS');
      if (!state.injectedLoaded || state.injectedChainId !== config.chainId) {
        await dispatch('loadBackupProvider');
      } else {
        /**
        this.providerStatus.activeChainId = this.providerStatus.injectedChainId;
        this.providerStatus.injectedActive = true;
        if (this.providerStatus.account)
          this.fetchUserBlockchainData(this.providerStatus.account);
        */
      }
    } catch (e) {
      commit('LOAD_WEB3_FAILURE', e);
      return Promise.reject();
    }
  },
  loadProvider: async ({ commit, dispatch }) => {
    commit('LOAD_PROVIDER_REQUEST');
    try {
      if (auth.provider.removeAllListeners) auth.provider.removeAllListeners();
      if (auth.provider.on) {
        auth.provider.on('chainChanged', async () => {
          commit('HANDLE_CHAIN_CHANGED');
          if (state.active) {
            await dispatch('loadWeb3');
          }
        });
        auth.provider.on('accountsChanged', async accounts => {
          if (accounts.length === 0) {
            if (state.active) await dispatch('loadWeb3');
          } else {
            commit('HANDLE_ACCOUNTS_CHANGED', accounts[0]);
            await dispatch('loadWeb3');
          }
        });
        auth.provider.on('disconnect', async () => {
          commit('HANDLE_CLOSE');
          if (state.active) await dispatch('loadWeb3');
        });
        auth.provider.on('networkChanged', async () => {
          commit('HANDLE_NETWORK_CHANGED');
          if (state.active) {
            await dispatch('loadWeb3');
          }
        });
      }
      const network = await web3.getNetwork();
      const accounts = await web3.listAccounts();
      const account = accounts.length > 0 ? accounts[0] : null;
      commit('LOAD_PROVIDER_SUCCESS', {
        injectedLoaded: true,
        injectedChainId: network.chainId,
        account,
        name
      });
    } catch (e) {
      commit('LOAD_PROVIDER_FAILURE', e);
      return Promise.reject();
    }
  },
  loadBackupProvider: async ({ commit }) => {
    try {
      web3 = rpcProvider;
      const network = await rpcProvider.getNetwork();
      commit('LOAD_BACKUP_PROVIDER_SUCCESS', {
        injectedActive: false,
        backUpLoaded: true,
        account: null,
        activeChainId: network.chainId
        // backUpWeb3: web3,
      });
    } catch (e) {
      commit('LOAD_BACKUP_PROVIDER_FAILURE', e);
      return Promise.reject();
    }
  },
  lookupAddress: async ({ commit }) => {
    commit('LOOKUP_ADDRESS_REQUEST');
    try {
      const name = await web3.lookupAddress(state.account);
      commit('LOOKUP_ADDRESS_SUCCESS', name);
      return name;
    } catch (e) {
      commit('LOOKUP_ADDRESS_FAILURE', e);
    }
  },
  resolveName: async ({ commit }, payload) => {
    commit('RESOLVE_NAME_REQUEST');
    try {
      const address = await web3.resolveName(payload);
      commit('RESOLVE_NAME_SUCCESS');
      return address;
    } catch (e) {
      commit('RESOLVE_NAME_FAILURE', e);
      return Promise.reject();
    }
  },
  sendTransaction: async (
    { commit },
    [contractType, contractAddress, action, params]
  ) => {
    commit('SEND_TRANSACTION_REQUEST');
    try {
      const signer = web3.getSigner();
      const contract = new Contract(
        getAddress(contractAddress),
        abi[contractType],
        web3
      );
      const contractWithSigner = contract.connect(signer);
      const tx = await contractWithSigner[action](...params);
      await tx.wait();
      commit('SEND_TRANSACTION_SUCCESS');
      return tx;
    } catch (e) {
      commit('SEND_TRANSACTION_FAILURE', e);
      return Promise.reject();
    }
  },
  signMessage: async ({ commit }, message) => {
    commit('SIGN_MESSAGE_REQUEST');
    try {
      const signer = web3.getSigner();
      const sig = await signer.signMessage(message);
      commit('SIGN_MESSAGE_SUCCESS');
      return sig;
    } catch (e) {
      commit('SIGN_MESSAGE_FAILURE', e);
      return Promise.reject(e);
    }
  },
  getBlockNumber: async ({ commit }) => {
    commit('GET_BLOCK_REQUEST');
    try {
      const blockNumber: any = await rpcProvider.getBlockNumber();
      commit('GET_BLOCK_SUCCESS', parseInt(blockNumber));
      return blockNumber;
    } catch (e) {
      commit('GET_BLOCK_FAILURE', e);
      return Promise.reject();
    }
  },



  // ===== methods ↓ =====
  getUserWalletBalance: async ({ commit }, obj) => {
    console.log('=== into === getUserWalletBalance:',obj)
    let {address_my} = obj
    const b_num = await web3.getBalance(address_my);
    let b = formatEther(b_num)
    return b;
  },

  
  getUserAllHorse: async ({ commit }, obj) => {
    console.log('=== into === getUserAllHorse:',obj)

    let {address_my} = obj
      const signer = web3.getSigner();
      const horse_contract = new Contract(HORSE_INTERFACE, HORSE_INTERFACE_ABI, web3);
      const horse_WithSigner = horse_contract.connect(signer);
      
      const b = await horse_WithSigner.tokensOfOwner(address_my);
      console.log('b:',b)

      let result:any = []
      for (let index = 0; index < b.length; index++) {

        let horse = b[index]['Lion'];
        let horseId = parseInt(b[index]['LionId']);
        let h = fromResultToHorse(horse,horseId)

        h['is_in_stud'] = b[index]['isOnAuction']

        h['auctionInfo'] = fromResultToAuction(b[index]['auctionInfo'])

        h['breedLimitInfo'] = fromResultToBreedLimitInfo(horse)

        h['price'] = formatEther(b[index]['price']);

        console.log(h)
        result.push(h);
      }
      return result;
  },



  getHorseInfo: async ({ commit }, obj) => {
    
    
    let {horseID} = obj

      const signer = web3.getSigner();
      const horse_contract = new Contract(HORSE_INTERFACE, HORSE_INTERFACE_ABI, web3);
      const horse_WithSigner = horse_contract.connect(signer);
      
      const b = await horse_WithSigner.getLionDetail(horseID);
      console.log('b:',b)

      let _horse = b['Lion'];
        
      // console.log(_horse);
      
      let h = fromResultToHorse(_horse['Lion'],horseID)

        h['is_in_stud'] = _horse['isOnAuction']


        h['auctionInfo'] = fromResultToAuction(_horse['auctionInfo'])

        h['breedLimitInfo'] = fromResultToBreedLimitInfo(_horse['Lion'])


        h['sire'] = fromResultToHorse(b['sire']['Lion'],h['sireId'])

        h['matron'] = fromResultToHorse(b['matron']['Lion'],h['matronId'])
  
        let di:any = []
        let offsprings = b['offsprings']
        for (let index = 0; index < offsprings.length; index++) {
          const element = offsprings[index]['Lion'];
          // di[index] = fromResultToHorse(element,h['offsprings'][index]);
          di[index] = {
            'horse':fromResultToHorse(element,parseInt(b['offsprings'][index]['LionId'])),
          }
        }
        h['offsprings'] = di;

        h['price'] =  formatEther(b['price']);


        // console.log('----------------------------------------------')
        console.log(h)
        return h

      
  },


  setHorseName: async ({ commit }, obj) => {
    // console.log('=== into === setHorseName:',obj)
    let {horse_data,name} = obj
    let horseID = horse_data['tokenID']
      const signer = web3.getSigner();
      const horse_contract = new Contract(HORSE_ADDRESS, HORSE_ABI, web3);
      const horse_WithSigner = horse_contract.connect(signer);
      await horse_WithSigner.setLionName(horseID, name);
  },


  getMiniAuctionPrice: async ({ commit }, obj) => {
    return 0;
    // console.log('=== into === getMiniAuctionPrice:',obj)
    // let {horse_data} = obj
    // let horseID = horse_data['tokenID']
    
    //   const signer = web3.getSigner();
    //   const horse_contract = new Contract(HORSE_ADDRESS, HORSE_ABI, web3);
    //   const horse_WithSigner = horse_contract.connect(signer);
    //   let b_num = await horse_WithSigner.getMiniBreedingPrice(horseID);
    //   let b = formatEther(b_num)
    //   return b;
  },

  

  createAuction: async ({ commit }, obj) => {
    // console.log('=== into === createAuction:',obj)

    let {form_price,form_day,horse_data} = obj

    let horseID = horse_data['tokenID']
    let price = parseEther(form_price)
    let duration = parseInt(form_day) * 24 * 3600
    
      const signer = web3.getSigner();
      const horse_contract = new Contract(HORSE_ADDRESS, HORSE_ABI, web3);
      const horse_WithSigner = horse_contract.connect(signer);
      await horse_WithSigner.createSiringAuction(horseID,price,duration);
  },


  getAuctionAllHorse: async ({ commit }, obj) => {
    // console.log('=== into === getAuctionAllHorse:',obj)

    const NOW = Math.ceil(Date.now() / 1000);
    // console.log('----',NOW)

      const client = new ApolloClient({
        link: httpLink,
        cache,
      });
    
      let page = (obj.page - 1) || 0
      let numPerPage = obj.numPerPage || 102
      let skip = page * numPerPage
  
      // lions(orderBy:internalID, orderDirection: desc, first:${numPerPage}, skip:${skip}, where:{id_gt:0})
  
      const USER = (address: any) => {
        const queryString = `
            query auctions{
              auctions(orderBy:price, orderDirection: asc, first:${numPerPage}, skip:${skip},where:{endAt_gt:${NOW}}){
                id
                lion {
                  id
                  name
                  gender
                  hair
                  eye
                  mouth
                  background
                  generation
                  birthTime
                  matronId
                  sireId
                  offsprings
                }
                price
                duration
                startedAt
                endAt
              }
            }
          `
        return gql(queryString)
      }
  
      const oneDayResult = await client.query({
        query: USER(''),
        fetchPolicy: 'network-only',
      })
  
      // console.log('testApollo res:')
      // console.log(oneDayResult)
  
      let data = oneDayResult.data.auctions;
      // console.log(data)
  
      let res: any[] = []
      for (let index = 0; index < data.length; index++) {
        let element = data[index];
        // console.log(element)


        let horse = element['lion'];
        
        // console.log(horse)

        let horseId = parseInt(horse['id']);

        // console.log('----------------09')

        let h = fromResultToHorse(horse,horseId)
  
        h['is_in_stud'] = true

        // console.log("--------------008");
  
        h['auctionInfo'] = fromResultToAuction(element)
  
        // h['breedLimitInfo'] = fromResultToBreedLimitInfo(horse)
  
        // h['horseRaceInfo'] = fromResultToHorseRaceInfo(element)
  
        
        // console.log(h)
        res.push(h)
      }
      // console.log("--------------009");
      console.log(res)
      return res
  },


  hasApproveBid: async ({ commit },obj) => {
    console.log('=== into === hasApproveBid')
    let {address} = obj
    const signer = web3.getSigner();
    const lp_contract = new Contract(TOKEN_ADDRESS, ERC20_ABI, web3);
    const lp_WithSigner = lp_contract.connect(signer);
    const b_num = await lp_WithSigner.allowance(address,AUCTION_ADDRESS);
    if(b_num > 0){
      return true;
    }
    return false;
  },

  
  approveBid: async (context,obj) => {
    console.log('=== into === approveBid')
    const signer = web3.getSigner();
    const lp_contract = new Contract(TOKEN_ADDRESS, ERC20_ABI, web3);
    const lp_WithSigner = lp_contract.connect(signer);

    try{
      await lp_WithSigner.approve(AUCTION_ADDRESS,parseUnits('1',36));
      if(obj && obj.callback){
        obj.callback()
      }
    }
    catch{
      if (obj && obj.callbackErr) {
        obj.callbackErr()
      }
    }
  },


  bid: async ({ commit }, obj) => {
    // console.log('=== into === bid:',obj)
    let {horse_male,horse_my} = obj
    let sireID = horse_male['tokenID']
    let matronID = horse_my['tokenID']
    // let price = parseEther(horse_male['auctionInfo']['price'])

      const signer = web3.getSigner();
      const horse_contract = new Contract(HORSE_ADDRESS, HORSE_ABI, web3);
      const horse_WithSigner = horse_contract.connect(signer);
      var tx =  await horse_WithSigner.bidOnSiringAuction(sireID,matronID,{gasLimit:GAS_Limit})

      await web3.waitForTransaction(tx.hash);
      let receipt = await web3.getTransactionReceipt(tx.hash);
      // console.log(receipt);
      let result = receipt['status']
      if (result > 0){
        console.log('true')
        return true;
      }
      console.log('false')
      return false;
  },

  getBidResult: async ({ commit }, address) => {
    console.log('=== into === getBidResult,',address)
   
    let horseID = 1
    {
      const signer = web3.getSigner();
      const horse_contract = new Contract(HORSE_ADDRESS, HORSE_ABI, web3);
      const horse_WithSigner = horse_contract.connect(signer);
      horseID = horse_WithSigner.getLastBirth(address);
    }
    console.log("getBidResult:",horseID)

    const signer = web3.getSigner();
    const horse_contract = new Contract(HORSE_INTERFACE, HORSE_INTERFACE_ABI, web3);
    const horse_WithSigner = horse_contract.connect(signer);
    const b = await horse_WithSigner.getLionDetail(horseID);
    console.log('b:',b)
    let _horse = b['Lion'];
    let h = fromResultToHorse(_horse['Lion'],horseID)
    console.log(h)
    return h
    
  },


  createHorse: async ({ commit }, obj) => {
    // console.log('=== into === createL:',obj)
    let {address_my} = obj
    
    
    const signer = web3.getSigner();
    const horse_contract = new Contract(TOKEN_ADDRESS, ERC20_ABI, web3);
    const horse_WithSigner = horse_contract.connect(signer);
    await horse_WithSigner.mint(address_my,parseUnits('1',22),{gasLimit:GAS_Limit});
    
    
    // const signer = web3.getSigner();
    // const horse_contract = new Contract(a_INTERFACE, a_ABI, web3);
    // const horse_WithSigner = horse_contract.connect(signer);
    // await horse_WithSigner.emergencyWithdraw();

  },

  createMaleHorse: async ({ commit }, obj) => {
    console.log('=== into === createMaleHorse:',obj)
    let {address_my} = obj
    const signer = web3.getSigner();
    const horse_contract = new Contract(HORSE_ADDRESS, HORSE_ABI, web3);
    const horse_WithSigner = horse_contract.connect(signer);
    await horse_WithSigner.createMaleLion(address_my);
    // await horse_WithSigner.mintLion(address_my);
  },

  createFemaleHorse: async ({ commit }, obj) => {
    // console.log('=== into === createFemaleHorse:',obj)
    let {address_my} = obj
    const signer = web3.getSigner();
    const horse_contract = new Contract(HORSE_ADDRESS, HORSE_ABI, web3);
    const horse_WithSigner = horse_contract.connect(signer);
    await horse_WithSigner.createFeMaleLion(address_my);
    // await horse_WithSigner.mintLion(address_my);
  },


  hasApproveMint: async ({ commit },obj) => {
    console.log('=== into === hasApproveMint:',obj)
    let {address_my} = obj
    const signer = web3.getSigner();
    const lp_contract = new Contract(TOKEN_ADDRESS, ERC20_ABI, web3);
    const lp_WithSigner = lp_contract.connect(signer);
    const b_num = await lp_WithSigner.allowance(address_my,HORSE_ADDRESS);
    if(b_num > 0){
      return true;
    }
    return false;
  },

  
  approveMint: async (context,obj) => {
    console.log('=== into === approveMint:',obj)
    const signer = web3.getSigner();
    const lp_contract = new Contract(TOKEN_ADDRESS, ERC20_ABI, web3);
    const lp_WithSigner = lp_contract.connect(signer);

    try{
      await lp_WithSigner.approve(HORSE_ADDRESS,parseUnits('1',36));
      if(obj && obj.callback){
        obj.callback()
      }
    }
    catch{
      if (obj && obj.callbackErr) {
        obj.callbackErr()
      }
    }
  },

  mintLion: async ({ commit }, obj) => {
    console.log('=== into === mintLion:',obj)
    let {address_my} = obj
    const signer = web3.getSigner();
    const horse_contract = new Contract(HORSE_ADDRESS, HORSE_ABI, web3);
    const horse_WithSigner = horse_contract.connect(signer);
    var tx = await horse_WithSigner.mintLion(address_my);
    

    await web3.waitForTransaction(tx.hash);
    let receipt = await web3.getTransactionReceipt(tx.hash);
    // console.log(receipt);
    let result = receipt['status']
    if (result > 0){
      console.log('true')
      return true;
    }
    console.log('false')
    return false;
  },

  getMintResult: async ({ commit }, address) => {
    console.log('=== into === getMintResult,',address)
   
    let horseID = 1
    {
      const signer = web3.getSigner();
      const horse_contract = new Contract(HORSE_ADDRESS, HORSE_ABI, web3);
      const horse_WithSigner = horse_contract.connect(signer);
      horseID = horse_WithSigner.getLastMint(address);
    }
    const signer = web3.getSigner();
    const horse_contract = new Contract(HORSE_INTERFACE, HORSE_INTERFACE_ABI, web3);
    const horse_WithSigner = horse_contract.connect(signer);
    const b = await horse_WithSigner.getLionDetail(horseID);
    console.log('b:',b)
    let _horse = b['Lion'];
    let h = fromResultToHorse(_horse['Lion'],horseID)
    console.log(h)
    return h
    
  },

  

  getMintcounter: async ({ commit }, obj) => {
    console.log('=== into === getMintcounter:',obj)
    const signer = web3.getSigner();
    const horse_contract = new Contract(HORSE_ADDRESS, HORSE_ABI, web3);
    const horse_WithSigner = horse_contract.connect(signer);
    let b = await horse_WithSigner.getMintCounter();
    console.log("getMintcounter:",b)
    return 7200 - b;
  },


  getAllHorse: async ({ commit }, obj) => {
    // console.log('=== into === getAuctionAllHorse:',obj)

      const client = new ApolloClient({
        link: httpLink,
        cache,
      });

      let page = (obj.page - 1) || 0
      let numPerPage = obj.numPerPage || 102
      let skip = page * numPerPage

      console.log(page)
      console.log(numPerPage)
  
      // const USER = (address: any) => {
      //   const queryString = `
      //       query lions{
      //         lions(orderBy:internalID, orderDirection: desc, first:${numPerPage}, skip:${skip}, where:{id_gt:0}){
      //             id
      //             name
      //             gender
      //             hair
      //             eye
      //             mouth
      //             background
      //             generation
      //             birthTime
      //             matronId
      //             sireId
      //             offsprings
      //         }
      //       }
      //     `
      //   return gql(queryString)
      // }

      const USER = (address: any) => {
        const queryString = `
            query lions{
              lions(orderBy:price, orderDirection: desc, first:${numPerPage}, skip:${skip}, where:{id_gt:0}){
                  id
                  name
                  gender
                  hair
                  eye
                  mouth
                  background
                  generation
                  birthTime
                  matronId
                  sireId
                  offsprings
                  price
              }
            }
          `
        return gql(queryString)
      }
  
      const oneDayResult = await client.query({
        query: USER(''),
        fetchPolicy: 'network-only',
      })
  
      // console.log('testApollo res:')
      // console.log(oneDayResult)
  
      let data = oneDayResult.data.lions;
      // console.log(data)
  
      let res: any[] = []
      for (let index = 0; index < data.length; index++) {
        let element = data[index];
        // console.log(element)

        let horse = element;
        
        // console.log(horse)

        let horseId = parseInt(horse['id']);

        // console.log('----------------09')

        let h = fromResultToHorse(horse,horseId)
  
        // h['is_in_stud'] = false
  
        // h['auctionInfo'] = fromResultToAuction(element)
  
        // h['breedLimitInfo'] = fromResultToBreedLimitInfo(horse)
  
        // h['horseRaceInfo'] = fromResultToHorseRaceInfo(element)
        
        h['price'] = formatEther(horse['price'])
        
        // console.log(h)
        res.push(h)
      }
  
      console.log(res)
      return res
  },



  hasApproveNFTMarket: async ({ commit }, obj) => {
    console.log('=== into === hasApproveNFTMarket',obj);
    let {address} = obj
    const signer = web3.getSigner();
    const horse_contract = new Contract(HORSE_ADDRESS, HORSE_ABI, web3);
    const horse_WithSigner = horse_contract.connect(signer);
    let b_num =  await horse_WithSigner.isApprovedForAll(address, nft_market_address);
    if(b_num > 0){
      return true;
    }
    return false;
  },
  
  approveNFTMarket: async ({ commit }, obj) => {
    const signer = web3.getSigner();
    const horse_contract = new Contract(HORSE_ADDRESS, HORSE_ABI, web3);
    const horse_WithSigner = horse_contract.connect(signer);
    await horse_WithSigner.setApprovalForAll(nft_market_address, true);
  },


  createAskOrder: async ({ commit }, obj) => {
    console.log('=== into === createAskOrder:',obj)
    let {form_price,horse_data} = obj
    let horseID = horse_data['tokenID']
    let price = parseEther(form_price)
    const signer = web3.getSigner();
    const horse_contract = new Contract(nft_market_address, nft_market_ABI, web3);
    const horse_WithSigner = horse_contract.connect(signer);
    await horse_WithSigner.createAskOrder(HORSE_ADDRESS, horseID, price);
  },


  cancelAskOrder: async ({ commit }, obj) => {
    console.log('=== into === cancelAskOrder:',obj)
    let {horse_data} = obj
    let horseID = horse_data['tokenID']
    
    const signer = web3.getSigner();
    const horse_contract = new Contract(nft_market_address, nft_market_ABI, web3);
    const horse_WithSigner = horse_contract.connect(signer);
    await horse_WithSigner.cancelAskOrder(HORSE_ADDRESS, horseID);
  },


  hasApproveBuy: async ({ commit },obj) => {
    console.log('=== into === hasApproveBuy')
    let {address} = obj
    const signer = web3.getSigner();
    const lp_contract = new Contract(TOKEN_ADDRESS, ERC20_ABI, web3);
    const lp_WithSigner = lp_contract.connect(signer);
    const b_num = await lp_WithSigner.allowance(address,nft_market_address);
    if(b_num > 0){
      return true;
    }
    return false;
  },

  
  approveBuy: async (context,obj) => {
    console.log('=== into === approveBuy')
    const signer = web3.getSigner();
    const lp_contract = new Contract(TOKEN_ADDRESS, ERC20_ABI, web3);
    const lp_WithSigner = lp_contract.connect(signer);

    try{
      await lp_WithSigner.approve(nft_market_address,parseUnits('1',36));
      if(obj && obj.callback){
        obj.callback()
      }
    }
    catch{
      if (obj && obj.callbackErr) {
        obj.callbackErr()
      }
    }
  },


  buyNFT: async ({ commit }, obj) => {
    console.log('=== into === buyNFT:',obj)
    let {form_price,horse_data} = obj
    let horseID = horse_data['tokenID']
    let price = parseEther(form_price)
    const signer = web3.getSigner();
    const horse_contract = new Contract(nft_market_address, nft_market_ABI, web3);
    const horse_WithSigner = horse_contract.connect(signer);
    await horse_WithSigner.buyTokenUsingWBNB(HORSE_ADDRESS, horseID, price);
  },


};

export default {
  state,
  mutations,
  actions
};
